import CustomErrorMessage from './CustomErrorMessage';

export default function Page404() {
  return (
    <CustomErrorMessage
      code={404}
      title="We can't find this form"
      body="The link may be mistyped, or the business may have taken this form down. If you scanned a QR code, ask them for an up-to-date one."
    />
  );
}
